<section id="secao-pilares">
  <div class="container-fluid p-0">
    <div class="row">
      <div routerLink="/educacao-tecnologica" class="col pilares p-0">
        <div class="overlay"></div>
        <img src="assets/imagens/educacao-tecnologica.png" class="card-image" />
        <div class="card-title">
          <span class="hover-underline-animation">Iniciação Tecnológica</span>
        </div>
      </div>
      <div routerLink="/empreendedorismo-inovacao" class="col pilares p-0">
        <img src="assets/imagens/empreendedorismo-e-inovacao.png" class="card-image" />
        <div class="card-title">
          <span class="hover-underline-animation">Incubação de Empresas</span>
        </div>
      </div>
      <div (click)="openExternalLink('https://educereangels.com.br/')" class="col pilares p-0" style="cursor: pointer;">
        <img src="assets/imagens/cultura-colaborativa.png" class="card-image" />
        <div class="card-title">
          <span class="hover-underline-animation">Aceleração de Negócios</span>
        </div>
      </div>
      <div routerLink="/cultura-colaborativa" class="col pilares p-0">
        <img src="assets/imagens/apoio-cultural.png" class="card-image" />
        <div class="card-title">
          <span class="hover-underline-animation">Cultura Colaborativa</span>
        </div>
      </div>
    </div>
  </div>
</section>